export const formatDate = 'DD-MM-YYYY';
export const formatMonth = 'MM';
export const formatYear = 'YYYY';
export const monthString = 'months';
export const yearString = 'years';
export const dayString = 'days';
export const addOperation = 'add';
export const subOperation = 'sub';
